import {defineStore} from 'pinia'
import {DestinationTrend, ScanSeries, ShortSummary, Trend} from "@/scripts/types/analytics";
import {
    getDestinationTrends,
    getDeviceTrends,
    getScansForEachHours,
    getCitiesTrends,
    getCodeTrends,
    getScans,
    getShortSummary,
    getUniqScans
} from "@/scripts/api/analytics";

interface State {
    deviceTrendsData: Trend[],
    scansForEachHourData: Trend[],
    destinationTrendsData: DestinationTrend[],
    citiesTrendsData: Trend[],
    codeTrends: Trend[],
    scans: ScanSeries[],
    uniqScans: ScanSeries[],
    shortSummary: ShortSummary
}

export const useAnalytics = defineStore('useAnalytics', {
    state: (): State => ({
        deviceTrendsData: [],
        scansForEachHourData: [],
        destinationTrendsData: [],
        citiesTrendsData: [],
        codeTrends: [],
        scans: [],
        uniqScans: [],
        shortSummary: null
    }),

    actions: {
        async loadDeviceTrends(from: string, to: string, codeIdentifier: any = null) {
            this.deviceTrendsData = await getDeviceTrends(from, to, codeIdentifier)
        },

        async loadScansForEachHour(from: string, to: string, codeIdentifier: any = null) {
            this.scansForEachHourData = await getScansForEachHours(from, to, codeIdentifier)
        },

        async loadDestinationTrends(from: string, to: string, codeIdentifier: any = null) {
            this.destinationTrendsData = await getDestinationTrends(from, to, codeIdentifier)
        },

        async loadCitiesTrends(from: string, to: string, codeIdentifier: any = null) {
            this.citiesTrendsData = await getCitiesTrends(from, to, codeIdentifier)
        },

        async loadCodeTrends(from: string, to: string, codeIdentifier: any = null) {
            this.codeTrends = await getCodeTrends(from, to, codeIdentifier)
        },

        async loadScans(from: string, to: string, codeIdentifier: any = null) {
            this.scans = await getScans(from, to, codeIdentifier)
        },

        async loadUniqScans(from: string, to: string, codeIdentifier: any = null) {
            this.uniqScans = await getUniqScans(from, to, codeIdentifier)
        },

        async loadShortSummary(codeIdentifier: any = null) {
            this.shortSummary = await getShortSummary(codeIdentifier)
        },
    }
})
